module.exports = __webpack_public_path__ + "static/PSS-icon-07-9b7a31aa057d52d93549becc52b4634b.png";